import { render, staticRenderFns } from "./AppealInfo.vue?vue&type=template&id=2106044d&scoped=true"
import script from "./AppealInfo.vue?vue&type=script&lang=js"
export * from "./AppealInfo.vue?vue&type=script&lang=js"
import style0 from "./AppealInfo.vue?vue&type=style&index=0&id=2106044d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106044d",
  null
  
)

export default component.exports